import DirectApi from '../../directApi';

let abortController = null;

export const fetchDataPromises = requestObjects => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	if (window.AbortController) {
		//Not supported by IE
		abortController = new window.AbortController();
	}
	const signal = abortController ? abortController.signal : undefined;
	const promises = [];

	for (const requestObject of requestObjects) {
		const init = {headers, signal, credentials: 'include', method: requestObject.method, body: requestObject.body ? JSON.stringify(requestObject.body) : undefined};
		promises.push(
			fetch(requestObject.url, init)
				.then(response => {
					if (response.ok) {
						return response.json();
					} else {
						return {error: true};
					}
				})
				.catch(error => {
					//Most likely aborted in unmount
					if (!('' + error).includes('abort')) {
						throw error;
					}
				})
		);
	}

	return Promise.all(promises);
};

export const fetchInit = shareUrl => {
	const headers = new Headers();
	if (shareUrl) {
		headers.append('X-FORECAST-PROJECT-SCHEDULING-SHARE', shareUrl);
	}
	const init = {headers, method: 'GET'};
	if (!shareUrl) {
		init.credentials = 'include';
	}
	return DirectApi.Fetch('scheduling/init', init).then(response => response.json());
};
